import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';

const da1 = 'da1';
const da2 = 'da2';
const db1 = 'db1';
const db2 = 'db2';
const dc1 = 'dc1';
const dc2 = 'dc2';
const dd1 = 'dd1';
const dd2 = 'dd2';
const de1 = 'de1';
const de2 = 'de2';
const dd1vg3 = 'dd1vg3';
const dd2vg3 = 'dd2vg3';
const dd3vg3 = 'dd3vg3';

export const DaValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'da1',
        value: da1,
        tekst: 'da1',
    },
    {
        id: 'da2',
        value: da2,
        tekst: 'da2',
    }
]
export const DbValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'ba1',
        value: db1,
        tekst: 'db1',
    },
    {
        id: 'db2',
        value: db2,
        tekst: 'db2',
    }
]

export const DcValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'dc1',
        value: dc1,
        tekst: 'dc1',
    },
    {
        id: 'dc2',
        value: dc2,
        tekst: 'dc2',
    }
]

export const DdValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'dd1',
        value: dd1,
        tekst: 'dd1',
    },
    {
        id: 'dd2',
        value: dd2,
        tekst: 'dd2',
    }
]

export const DdVg3Valg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'dd1vg3',
        value: dd1vg3,
        tekst: 'dd1Vg3',
    },
    {
        id: 'dd2vg3',
        value: dd2vg3,
        tekst: 'dd2Vg3',
    },
    {
        id: 'dd3vg3',
        value: dd3vg3,
        tekst: 'dd3Vg3',
    }
]

export const DeValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'de1',
        value: de1,
        tekst: 'de1',
    },
    {
        id: 'de2',
        value: de2,
        tekst: 'de2',
    }
]

export default {
    da1: da1,
    da2: da2,
    db1: db1,
    db2: db2,
    dc1: dc1,
    dc2: dc2,
    dd1: dd1,
    dd2: dd2,
    dd1vg3: dd1vg3,
    dd2vg3: dd2vg3,
    dd3vg3: dd3vg3,
    de1: de1,
    de2: de2,

    DaValg,DbValg,DcValg,DdValg,DdVg3Valg,DeValg
};